import { render, staticRenderFns } from "./Packingmaterials.vue?vue&type=template&id=68fa9dc0&scoped=true"
import script from "./Packingmaterials.vue?vue&type=script&lang=js"
export * from "./Packingmaterials.vue?vue&type=script&lang=js"
import style0 from "./Packingmaterials.vue?vue&type=style&index=0&id=68fa9dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa9dc0",
  null
  
)

export default component.exports